export enum Errors {
  NoLinkError = `There's an error downloading the gift card. Please use the link we've sent to your email.`,
  DownloadError = `There's an error downloading the gift card. Please retry download or use the link we've sent to your email.`,
  NoError = '',
}
